import React, {useEffect, useState} from "react";

import {
    Actions,
    Benefits,
    Button,
    Container,
    DispatchTag,
    MethodCard,
    PriceCard,
    PriceRow,
    Row,
    ShieldIcon,
} from "./styles";
import {EMAIL_HELP_RESTAURANTE, PASSWORD_HELP_RESTAURANTE} from "../../../../../common/constantes";
import {IProduct} from "../../redux/productReducer";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import delivery from "../../../Marketplace/assets/images/delivery.svg";
import Typography from "@mui/material/Typography";

const Alert = React.forwardRef(function Alert(props, ref: any) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ProductAction: (props: { product: IProduct, addToCart: Function, goToCart: Function, goToLogin: Function }) => JSX.Element = (props: { product: IProduct, addToCart: Function, goToCart: Function, goToLogin: Function }) => {
    const [isPublicLink, setIsPublicLink] = useState(true);

    useEffect(() => {
        const email = localStorage.getItem(EMAIL_HELP_RESTAURANTE);
        const pass = localStorage.getItem(PASSWORD_HELP_RESTAURANTE);
        if (email && pass) {
            setIsPublicLink(false);
        }
    }, []);

    const [normalPriceDecimal, setNormalPriceDecimal] = useState('0');
    const [normalPriceCents, setNormalPriceCents] = useState('0');
    const [helpvinoPriceDecimal, setHelpvinoPriceDecimal] = useState('0');
    const [helpvinoPriceCents, setHelpvinoPriceCents] = useState('0');

    const [openToastAlreadySend, setOpenToastAlreadySend] = React.useState(false);

    const handleCloseAlreadySend = (event: Object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenToastAlreadySend(false);
    };

    useEffect(() => {

        const {normalPrice = 0, helpvinoPrice = 0} = props.product

        const stringNormalPrice = normalPrice.toFixed(2).toString().split('.');
        const stringHelpPrice = helpvinoPrice.toFixed(2).toString().split('.');

        setNormalPriceDecimal(stringNormalPrice[0]);
        setNormalPriceCents(stringNormalPrice[1]);

        setHelpvinoPriceDecimal(stringHelpPrice[0]);
        setHelpvinoPriceCents(stringHelpPrice[1]);

    }, [props.product])


    function percentage(partialValue: number, totalValue: number) {
        const total = (partialValue / totalValue) * 100;
        return (100 - total).toFixed(2).toString().replace('.', ',');
    }

    return (
        <Container>
            {/*<Condition>Lote</Condition>*/}

            <Row>
                <h1> {props.product.wineName} </h1>
                {/*<HeartIcon />*/}
            </Row>

            <DispatchTag>{percentage(props.product.helpvinoPrice || 0, props.product.normalPrice || 0)}% de
                desconto</DispatchTag>

            {/*<PriceCard>
        <span className="symbol min">de: </span>
        <div className={'cut'}>
          <PriceRow className={'min'}>
              <span className="symbol min">R$</span>
              <span className="fraction min">34</span>
              <span className="cents min">99</span>
          </PriceRow>
        </div>

        <InstallmentsInfo>em 3x de R$ 11,67</InstallmentsInfo>
      </PriceCard>*/}
            <PriceCard className={'adjuste-bottom-margin-product-action'}>
                <span className="symbol min">de: </span>
                <div>
                    <PriceRow>
                        <span className="symbol min">R$</span>
                        <span className="fraction del min">{normalPriceDecimal},</span>
                        <span className="cents del min">{normalPriceCents}</span>
                    </PriceRow>
                </div>

                {/*<InstallmentsInfo>em 3x de R$ 11,67</InstallmentsInfo>*/}
            </PriceCard>
            <PriceCard>
                <span className="symbol min">por: </span>
                <div className={'container-price-row'}>
                    <PriceRow>
                        <span className="symbol adjust-bottom">R$</span>
                        <span className="fraction">{helpvinoPriceDecimal},</span>
                        <span className="cents">{helpvinoPriceCents}</span>
                    </PriceRow>
                </div>

                {/*<InstallmentsInfo>em 3x de R$ 11,67</InstallmentsInfo>*/}
            </PriceCard>

            {/*<StockStatus>Estoque disponível</StockStatus>*/}

            <MethodCard>

                <div>
                    <span className="details">*1 caixa {`contém ${props.product.packageQuantity} unidades`}</span>
                </div>
            </MethodCard>
            <MethodCard>
                <Typography variant="body2" color="text.secondary" className={'sale-delivery-time'}>
                    <img src={delivery} alt={' '} style={{
                        width: 35,
                        marginRight: 7
                    }} />  Chegará em {`${props.product.estimatedDeliveryTimeInDays} dia${props.product.estimatedDeliveryTimeInDays > 1 ? 's' : ''}`}
                </Typography>
            </MethodCard>

            <Actions>
                <Button solid onClick={() => {
                    if (isPublicLink) {
                        props.goToLogin();
                        return;
                    }
                    props.addToCart(props.product.activeJointPurchaseOrderId, 1);

                    props.goToCart();
                }}>Comprar agora</Button>
                {!isPublicLink && (
                    <Button onClick={() => {
                        props.addToCart(props.product.activeJointPurchaseOrderId, 1);
                        setOpenToastAlreadySend(true)
                    }}>Adicionar ao carrinho</Button>
                )}
            </Actions>

            <Benefits>
                <li>
                    <ShieldIcon/>
                    <p>
                        Compra garantida pela Helpvino.
                    </p>
                </li>
                <div className="fb-share-button" data-href="https://developers.facebook.com/docs/plugins/"
                     data-layout="button_count" data-size="small"><a target="_blank"
                                                                     rel="noreferrer"
                                                                     href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
                                                                     className="fb-xfbml-parse-ignore">Compartilhar</a>
                </div>
            </Benefits>

            <Snackbar anchorOrigin={{vertical: 'top', horizontal: 'center'}} open={openToastAlreadySend}
                      autoHideDuration={2000} onClose={handleCloseAlreadySend}>
                <Alert onClose={handleCloseAlreadySend} severity="success" sx={{width: '100%'}}>
                    Produto foi adicionado ao carrinho.
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default ProductAction;
